import React, { FunctionComponent } from 'react';

const Rectangle: FunctionComponent = () => (
  <svg width="335" height="169" viewBox="0 0 335 169" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M335 0H249L0 140.774V169H28L335 86.4524V0Z" fill="#D90855" />
  </svg>
);

export default Rectangle;
